export default {"src":"/_next/static/media/wandai.ffb4d3da.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};